/** نگاشت نوع کاربر (هم‌نام enum بک‌اند) */
export const USER_KIND = {
  Management: "Management",
  SolarentOperator: "SolarentOperator",
  Customer: "Customer",
  Contractor: "Contractor",
  Supplier: "Supplier",
  Investor: "Investor",
  Supervisor: "Supervisor",
  Satba: "Satba",
  DistributionCompany: "DistributionCompany",
};

const USER_KIND_NUMERIC = {
  2: USER_KIND.Management,
  3: USER_KIND.SolarentOperator,
  4: USER_KIND.Customer,
  5: USER_KIND.Contractor,
  6: USER_KIND.Supplier,
  7: USER_KIND.Investor,
  8: USER_KIND.Supervisor,
  9: USER_KIND.Satba,
  10: USER_KIND.DistributionCompany,
};

const ROLE_NAME_TO_USER_KIND = {
  مدیریت: USER_KIND.Management,
  "کارشناسان سولارنت": USER_KIND.SolarentOperator,
  متقاضی: USER_KIND.Customer,
  پیمانکاران: USER_KIND.Contractor,
  "تامین کنندگان": USER_KIND.Supplier,
  "سرمایه گذاران": USER_KIND.Investor,
  "ناظران شرکت های توزیع": USER_KIND.Supervisor,
  "ناظران سولارنت": USER_KIND.Supervisor,
  "مدیران ساتبا": USER_KIND.Satba,
  "شرکت‌های توزیع": USER_KIND.DistributionCompany,
  "شرکت های توزیع": USER_KIND.DistributionCompany,
};

/** مقدار API (عدد یا رشته) را برای DropdownPicker آماده می‌کند. */
export function normalizeUserKindForForm(userKind) {
  if (userKind == null || userKind === "") return "";
  if (typeof userKind === "string" && USER_KIND[userKind]) return userKind;
  const num = Number(userKind);
  if (!Number.isNaN(num) && USER_KIND_NUMERIC[num]) {
    return USER_KIND_NUMERIC[num];
  }
  return String(userKind);
}

/** از نام گروه کاربری (نقش) نوع کاربر را حدس می‌زند. */
export function resolveUserKindFromRoleName(roleName) {
  if (!roleName) return null;
  const trimmed = String(roleName).trim();
  return ROLE_NAME_TO_USER_KIND[trimmed] ?? null;
}

export function resolveUserKindFromRoleId(roleId, roleList = []) {
  const role = roleList.find(
    (r) => r.roleId === roleId || r.id === roleId || r.Id === roleId
  );
  if (!role) return null;
  return resolveUserKindFromRoleName(role.roleName ?? role.RoleName);
}
